import { VALIDACIONES_FICHA } from '../forms/schemas/fichaSchema';

const obtenerValorCampo = (data, campo) => {
    const v = data?.[campo];
    if (v && typeof v === 'object' && Object.prototype.hasOwnProperty.call(v, 'valor')) {
        return v.valor;
    }
    return v;
};

const esVacio = (valor) => valor === undefined || valor === null || String(valor).trim() === '';

export const esNombreAdjuntoBorradorFicha = (nombreArchivo = '') =>
    /_BORRADOR\.pdf$/i.test(String(nombreArchivo || ''));

export const isFichaSeguimientoCompleta = ({
    data,
    tipoFicha,
    textoProteccionDatos,
    firmaRef,
    firmaRefResponsable,
    requiereDobleFirma = false,
}) => {
    if (!data || !tipoFicha) return false;

    if (textoProteccionDatos && !obtenerValorCampo(data, 'acepta_proteccion_datos')) {
        return false;
    }
    const configGeneral = VALIDACIONES_FICHA?.general;
    const reqGen = configGeneral?.required || [];
    for (const { key } of reqGen) {
        if (esVacio(obtenerValorCampo(data, key))) return false;
    }
    const pasos = Object.keys(VALIDACIONES_FICHA?.[tipoFicha] || {})
        .filter((k) => /^\d+$/.test(k))
        .map((k) => parseInt(k, 10))
        .sort((a, b) => a - b);
    for (const stepNumber of pasos) {
        const configPaso = VALIDACIONES_FICHA[tipoFicha][stepNumber];
        if (!configPaso) continue;
        const requiredFields = Array.isArray(configPaso.required) ? configPaso.required : [];
        for (const { key } of requiredFields) {
            if (esVacio(obtenerValorCampo(data, key))) return false;
        }
        const conditionalFields = Array.isArray(configPaso.conditionalRequired)
            ? configPaso.conditionalRequired
            : [];
        for (const { key, condition } of conditionalFields) {
            if (typeof condition === 'function' && condition(data) && esVacio(obtenerValorCampo(data, key))) {
                return false;
            }
        }
        const customValidations = configPaso?.customValidation
            ? Array.isArray(configPaso.customValidation)
                ? configPaso.customValidation
                : [configPaso.customValidation]
            : [];
        for (const validacion of customValidations) {
            if (validacion === 'sesiones') {
                const sesiones = data.sesiones || [];
                if (sesiones.length === 0) return false;
                const hay = sesiones.some(
                    (s) => s.asistencia || s.encuesta || s.reporte || s.nivel_riesgo || s.consentimiento
                );
                if (!hay) return false;
            }
            if (validacion === 'habilidades_comunicativas') {
                const campos = ['habcom_leer', 'habcom_escribir', 'habcom_escuchar', 'habcom_hablar'];
                if (!campos.some((c) => !!obtenerValorCampo(data, c))) return false;
            }
            if (validacion === 'habitos_estudio') {
                const campos = ['hab_Inspeccionar', 'hab_Preguntar', 'hab_Leer', 'hab_Escribir', 'hab_Repasar', 'hab_Otra'];
                if (!campos.some((c) => !!obtenerValorCampo(data, c))) return false;
            }
        }
    }
    if (esVacio(obtenerValorCampo(data, 'responsable_atencion'))) return false;
    if (esVacio(obtenerValorCampo(data, 'tp_responsable'))) return false;
    const firmaLlena = (ref) =>
        ref?.current &&
        (typeof ref.current.isEmpty !== 'function' || !ref.current.isEmpty());

    if (requiereDobleFirma) {
        return firmaLlena(firmaRef) && firmaLlena(firmaRefResponsable);
    }
    const refUnica = firmaRefResponsable?.current ? firmaRefResponsable : firmaRef;
    return firmaLlena(refUnica);
};
